<app-loading-generico [loadingGenerico]="loadingGenerico"></app-loading-generico>
<app-header></app-header>
<app-botao-chat></app-botao-chat>


<div class="container py-4">
  <div class="row">
    <div class="col-12">
      <div class="card">
        <app-breadcrumb></app-breadcrumb>
        <h1 class="titulo mb-5">Relatório Gerencial - Recarga Certa</h1>
        @if (erro) {
          <div class="text-center">
            <img src="/assets/img/erro.png" alt="representando erro na consulta dos dados de relatório" width="200px">
            <p class="legenda-erro">Ocorreu um erro na consulta dos dados.</p>
          </div>
        }
        @if (falhaPesquisa) {
          <div class="body-alert">
            <div class="div-alert text-center">
              <img class="mt-4" src="/assets/img/error.png" alt="representando falha na pesquisa dos dados do relatório" width="82px">
              <p class="titulo-alert mt-4 c-danger"> {{ mensagemErroSubtitulo }} </p>
              <div class="footer-alert bg-danger">
                <p class="subtitulo-alert"> {{ mensagemErro }} </p>
                <button class="btn-borda-branca btn-font-branco btn-grande-vermelho mt-3"
                (click)="fecharAlertErro()">SAIR</button>
              </div>
            </div>
          </div>
        }
        @if (!erro) {
          <div class="row mt-5">
            <div class="mb-4 col-lg-2">
              <label class="label-menor" for="valorAnoName">Emitir por período</label>
              <app-select
                id="valorAnoName"
                [value]="valorAno"
                (valueChanges)="valorAno = $event"
                name="valorAnoName"
                [options]="anos"
                optionValue="ano"
                optionText="ano">
              </app-select>
            </div>
            <div class="mb-4 col-lg-2">
              <label class="label-menor" for="siglaFormatoRelatorioName">Tipo de saída</label>
              <app-select
                [value]="siglaFormatoRelatorio"
                (valueChanges)="siglaFormatoRelatorio = $event"
                name="siglaFormatoRelatorioName"
                [options]="formatos"
                optionValue="sigla"
                optionText="formato"
                id="siglaFormatoRelatorioName">
              </app-select>
            </div>
            <div class="mb-4 col-lg-2">
              <br>
                <button class="botao-secundario px-5"
                                [ngClass]="{
                                  disabled: checkedUsersId.length == 0 || !('RelatoriosGerencialRecargaCerta' | usuarioPermissao:'Imprimir' | async)
                                }"
                  [disabled]="checkedUsersId.length == 0 || !('RelatoriosGerencialRecargaCerta' | usuarioPermissao:'Imprimir' | async)"
                (click)='getRelatorio()' id="listar">LISTAR</button>
              </div>
            </div>
            @if (!allAnosHasError) {
              <div class="row">
                <div class="col-12">
                  <!-- TABELA -->
                  <table class="table table-hover border-bottom mt-4">
                    <caption>Tabela com lista de empresas do relatório</caption>
                    <thead>
                      <tr>
                        <th scope="col">
                          <div class="form-check">
                            <input
                              type="checkbox"
                              class="form-check-input"
                              [(ngModel)]="selectAll"
                              [checked]="selectAllPed"
                              (change)="selectAllUserId($event)"
                              id="selectAllPedidos"
                              aria-label="selectAllPedidos"
                              >
                            <label class="form-check-label" for="selectAllPedidos"></label>
                          </div>
                        </th>
                        <th scope="col">CNPJ</th>
                        <th scope="col">RAZÃO SOCIAL</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (emp of resources | paginate: { id: 'enderecos', itemsPerPage: itemsPerPage , currentPage: currentPage, totalItems: totalItems} ; track emp; let i = $index) {
                        <tr
                          >
                          <td>
                            <div class="form-check">
                              <input
                                type="checkbox"
                                class="form-check-input"
                                id="checkbox{{ i }}"
                                [checked]="isChecked(emp.idEmpresa)"
                                (change)="onTableAddressClick(emp.idEmpresa)"
                                name="checkPedidos"
                                title="{{emp.idEmpresa}}"
                                [attr.aria-label]="emp.idEmpresa"
                                >
                              <label class="form-check-label" for="checkbox{{ i }}"></label>
                            </div>
                          </td>
                          <td>{{emp.cnpj | cnpj}}</td>
                          <td>{{emp.razaoSocial}}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }
            <div class="row mt-4 ">
              <div class="col-3 mb-4">
                <app-select
                  [value]="itemsPerPage"
                  (valueChanges)="itemsPerPage = $event"
                  name="itemsPerPageName"
                            [options]="[
                            {name : 'Exibir 5 Empresas' , value : '5'} ,
                            {name : 'Exibir 10 Empresas' , value : '10'} ,
                            {name : 'Exibir 15 Empresas' , value : '15'} ,
                            {name : 'Exibir 20 Empresas' , value : '20'}

                            ]"
                  optionValue="value"
                  optionText="name">
                </app-select>
              </div>
              <div class="col-6 mb-4 text-center ps-0">
                <pagination-controls class="bg-danger ps-0" id="enderecos" (pageChange)="getPage($event)"
                  (pageBoundsCorrection)="pageChanged($event)" directionLinks="true" autoHide="true"
                  responsive="true" previousLabel="Anterior" nextLabel="Próximo"
                  screenReaderPaginationLabel="Pagination" screenReaderPageLabel="page"
                  screenReaderCurrentLabel="Página">
                </pagination-controls>
              </div>
              <p class="texto-tabela col-3 text-nowrap text-end">
                <span>{{totalItemsExiba}}</span> Registros foram encontrados</p>
              </div>
            }

          </div>
        </div>
      </div>
    </div>

    <app-footer></app-footer>
